import { ReactNode, useMemo } from 'react';
import {
  Box,
  TCustomPalette,
  Theme,
  ApiaThemeProvider as TUIThemeProvider,
} from '@apia/theme';
import { merge } from 'lodash-es';
import getBurocrat from '../themes/burocrat/burocrat';
import ThemeAssigner from './ThemeAssigner';

export function useCustomizedBurocrat() {
  const burocrat = useMemo(() => getBurocrat(), []);
  const customTheme = useMemo(() => window.customTheme, []);
  const mergeTheme: () => Theme = useMemo(
    () => () => merge(burocrat, customTheme?.()),
    [burocrat, customTheme],
  );

  return mergeTheme;
}

const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const mergeTheme = useCustomizedBurocrat();

  return (
    <TUIThemeProvider
      customTheme={mergeTheme}
      customPalette={() =>
        window.customPalettes?.reduce(
          (result, current) => ({ ...result, ...current }),
          {} as TCustomPalette,
        )
      }
    >
      <ThemeAssigner />
      <Box {...window.getVariant('layout.root')}>{children}</Box>
    </TUIThemeProvider>
  );
};

export default ThemeProvider;
